module.exports = __webpack_public_path__ + "img/alipay.57d68908.jpg";